// Paginacao, ordenacao e filtro das avaliacoes da ficha de produto.
// A primeira pagina ja vem pronta do servidor (como na referencia); o acervo
// completo e buscado so no primeiro clique de pagina, ordem ou filtro.
(function () {
  // modal de nova avaliacao: nota, conteudo, sobre voce, agradecimento
  function ligarForm(abrir, modal) {
    var passos = modal.querySelectorAll('.ewc-form__passo');
    var voltar = modal.querySelector('[data-ewc-voltar]');
    var proximo = modal.querySelector('[data-ewc-proximo]');
    var enviar = modal.querySelector('[data-ewc-enviar]');
    var fechar = modal.querySelectorAll('[data-ewc-fechar]');
    var campoNota = modal.querySelector('[data-ewc-nota-campo]');
    var notas = modal.querySelectorAll('.ewc-form__nota');
    var envio = modal.querySelector('form');
    var passo = 1;

    function mostra(n) {
      passo = n;
      for (var i = 0; i < passos.length; i++) {
        passos[i].hidden = Number(passos[i].dataset.passo) !== n;
      }
      var fim = n === passos.length;
      voltar.hidden = n === 1 || fim;
      proximo.hidden = n >= passos.length - 1;
      enviar.hidden = n !== passos.length - 1;
      for (var j = 0; j < fechar.length; j++) {
        if (fechar[j].hasAttribute('data-so-no-fim')) fechar[j].hidden = !fim;
      }
    }

    function marcaNota(v) {
      campoNota.value = v;
      for (var i = 0; i < notas.length; i++) {
        var marcada = Number(notas[i].dataset.nota) <= v;
        notas[i].classList.toggle('esta-marcada', marcada);
        notas[i].setAttribute('aria-pressed', marcada ? 'true' : 'false');
      }
    }

    function abre(n) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      mostra(n || 1);
    }
    function fecha() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    abrir.addEventListener('click', function () { abre(1); });
    for (var k = 0; k < fechar.length; k++) fechar[k].addEventListener('click', fecha);
    modal.addEventListener('click', function (e) { if (e.target === modal) fecha(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) fecha();
    });
    for (var m = 0; m < notas.length; m++) {
      notas[m].addEventListener('click', function () {
        marcaNota(Number(this.dataset.nota));
        mostra(2);
      });
    }
    voltar.addEventListener('click', function () { mostra(Math.max(1, passo - 1)); });
    proximo.addEventListener('click', function () {
      // o passo seguinte so entra com o campo obrigatorio preenchido
      var atual = passos[passo - 1];
      var obrigatorios = atual.querySelectorAll('[required]');
      for (var i = 0; i < obrigatorios.length; i++) {
        if (!obrigatorios[i].reportValidity()) return;
      }
      mostra(passo + 1);
    });
    marcaNota(5);
    mostra(1);
    // de volta do envio o Shopify traz ?contact_posted=true: abre no agradecimento
    if (/[?&]contact_posted=true/.test(location.search) && envio) abre(passos.length);
  }

  function ligar(raiz) {
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';

    var lista = raiz.querySelector('[data-ewc-lista]');
    var nav = raiz.querySelector('[data-ewc-pag]');
    var ordem = raiz.querySelector('[data-ewc-ordem]');
    var btnFiltros = raiz.querySelector('[data-ewc-filtros]');
    var histograma = raiz.querySelector('[data-ewc-histograma]');
    var btnForm = raiz.querySelector('[data-ewc-abrir-form]');
    var form = raiz.querySelector('[data-ewc-form]');
    var porPagina = parseInt(raiz.dataset.porPagina, 10) || 5;
    var acervo = null;          // carregado sob demanda
    var pagina = 1;

    if (btnForm && form) ligarForm(btnForm, form);
    if (btnFiltros && histograma) {
      btnFiltros.addEventListener('click', function () {
        histograma.hidden = !histograma.hidden;
      });
    }

    function estrelas(nota) {
      var s = '<div class="ewc-estrelas" role="img" aria-label="' + nota + ' out of 5 stars">';
      for (var i = 1; i <= 5; i++) {
        var c = i <= Math.floor(nota) ? 'ewc-estrela'
              : (i === Math.floor(nota) + 1 && nota - Math.floor(nota) >= 0.5)
                ? 'ewc-estrela ewc-estrela--meia' : 'ewc-estrela ewc-estrela--vazia';
        s += '<svg class="' + c + '" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">'
           + '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27'
           + 'l6.91-1.01L12 2z"/></svg>';
      }
      return s + '</div>';
    }

    function escapa(t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : String(t);
      return d.innerHTML;
    }

    function dataCurta(iso) {
      var p = String(iso || '').slice(0, 10).split('-');
      return p.length === 3 ? p[1] + '/' + p[2] + '/' + p[0] : '';
    }

    // mesmo molde do snippet ewc-aval-item.liquid: mudar um, mudar o outro
    function molde(r) {
      var s = '<article class="ewc-aval__item">' + estrelas(r.nota)
        + '<div class="ewc-aval__quem"><span class="ewc-aval__avatar" aria-hidden="true">'
        + escapa(r.inicial) + '</span><div class="ewc-aval__quem-dados">'
        + '<p class="ewc-aval__autor"><span class="ewc-aval__nome">' + escapa(r.autor) + '</span>'
        + (r.verificado ? '<span class="ewc-aval__verificado">Verified</span>' : '')
        + '</p><p class="ewc-aval__data">' + dataCurta(r.data) + '</p></div></div>'
        + '<div class="ewc-aval__conteudo">'
        + (r.titulo ? '<p class="ewc-aval__item-titulo">' + escapa(r.titulo) + '</p>' : '')
        + '<p class="ewc-aval__corpo">' + escapa(r.corpo).replace(/\n/g, '<br>') + '</p>';
      if (r.fotos && r.fotos.length) {
        s += '<div class="ewc-aval__fotos">';
        for (var i = 0; i < r.fotos.length; i++) {
          var u = encodeURI(r.fotos[i]);
          s += '<a href="' + u + '" target="_blank" rel="noopener">'
             + '<img src="' + u + '" alt="" width="160" height="160" loading="lazy"></a>';
        }
        s += '</div>';
      }
      s += '</div>';
      if (r.para && raiz.dataset.produtoTitulo) {
        s += '<a class="ewc-aval__para" href="' + (raiz.dataset.produtoUrl || '#') + '">'
           + (raiz.dataset.produtoFoto
               ? '<img src="' + raiz.dataset.produtoFoto + '" alt="" width="48" height="48" loading="lazy">'
               : '')
           + '<span class="ewc-aval__para-texto">'
           + '<span class="ewc-aval__para-rotulo">Review for</span>'
           + '<span class="ewc-aval__para-nome">' + escapa(r.para) + '</span>'
           + '</span></a>';
      }
      return s + '</article>';
    }

    function ordenado() {
      var v = (ordem && ordem.value) || 'recentes';
      var r = acervo.slice();
      if (v === 'maior') r.sort(function (a, b) { return b.nota - a.nota; });
      else if (v === 'menor') r.sort(function (a, b) { return a.nota - b.nota; });
      else if (v === 'uteis') r.sort(function (a, b) { return (b.uteis || 0) - (a.uteis || 0); });
      else if (v === 'so-fotos') r = r.filter(function (x) { return x.fotos && x.fotos.length; });
      else if (v === 'fotos-primeiro') {
        r.sort(function (a, b) {
          return ((b.fotos || []).length > 0) - ((a.fotos || []).length > 0);
        });
      }
      return r;
    }

    function desenhaNav(paginas) {
      if (!nav) return;
      if (pagina > paginas) pagina = paginas;
      var s = '<button type="button" aria-label="Go to previous page"' +
              (pagina === 1 ? ' disabled' : '') + ' data-ir="' + (pagina - 1) + '">&#8249;</button>';
      // ate 4 numeros e a ultima, como a referencia faz quando ha muitas paginas
      var nums = [];
      for (var i = 1; i <= Math.min(4, paginas); i++) nums.push(i);
      if (paginas > 4 && nums.indexOf(paginas) === -1) nums.push(paginas);
      if (pagina > 4 && nums.indexOf(pagina) === -1) nums.splice(4, 0, pagina);
      for (var j = 0; j < nums.length; j++) {
        s += '<button type="button" data-ir="' + nums[j] + '"' +
             (nums[j] === pagina ? ' aria-current="true"' : '') + '>' + nums[j] + '</button>';
      }
      s += '<button type="button" aria-label="Go to next page"' +
           (pagina === paginas ? ' disabled' : '') + ' data-ir="' + (pagina + 1) + '">&#8250;</button>';
      nav.innerHTML = s;
    }

    // so chamada depois que o acervo chegou: antes disso a lista e a do servidor
    function desenha() {
      var r = ordenado();
      var paginas = Math.max(1, Math.ceil(r.length / porPagina));
      if (pagina > paginas) pagina = paginas;
      var ini = (pagina - 1) * porPagina;
      lista.innerHTML = r.slice(ini, ini + porPagina).map(molde).join('');
      desenhaNav(paginas);
    }

    function carrega() {
      if (acervo) return Promise.resolve();
      return fetch(raiz.dataset.acervo, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) { acervo = d.reviews || []; });
    }

    function age(fn) {
      carrega().then(function () { fn(); desenha(); }).catch(function () {
        // acervo indisponivel: a primeira pagina do servidor continua na tela
      });
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ir]');
        if (!b || b.disabled) return;
        var n = parseInt(b.dataset.ir, 10);
        age(function () { pagina = n; });
      });
      // a navegacao e pintada com a contagem que o servidor ja mandou,
      // sem baixar o acervo: ele so vem no primeiro clique
      desenhaNav(parseInt(raiz.dataset.paginas, 10) || 1);
    }
    if (ordem) {
      ordem.addEventListener('change', function () { age(function () { pagina = 1; }); });
    }
  }

  function tudo() {
    var ns = document.querySelectorAll('.ewc-aval');
    for (var i = 0; i < ns.length; i++) ligar(ns[i]);
  }
  function ligarTira() {
    var tiras = document.querySelectorAll('[data-ewc-tira]');
    for (var i = 0; i < tiras.length; i++) {
      (function (tira) {
        var itens = tira.querySelector('[data-ewc-tira-itens]');
        var antes = tira.querySelector('[data-ewc-tira-antes]');
        var depois = tira.querySelector('[data-ewc-tira-depois]');
        if (!itens || !antes || !depois) return;
        function medir() {
          var sobra = itens.scrollWidth - itens.clientWidth;
          antes.hidden = itens.scrollLeft <= 2;
          depois.hidden = itens.scrollLeft >= sobra - 2;
        }
        function andar(sinal) {
          itens.scrollBy({ left: sinal * (itens.clientWidth - 108), behavior: 'smooth' });
        }
        antes.addEventListener('click', function () { andar(-1); });
        depois.addEventListener('click', function () { andar(1); });
        itens.addEventListener('scroll', medir, { passive: true });
        window.addEventListener('resize', medir);
        medir();
      })(tiras[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tudo(); ligarTira(); });
  } else {
    tudo();
    ligarTira();
  }
})();
